export var StoreStatus;
(function (StoreStatus) {
    StoreStatus["Pending"] = "pending_store";
    StoreStatus["Active"] = "active_store";
    StoreStatus["Closed"] = "closed_store";
})(StoreStatus || (StoreStatus = {}));
